<template>
	<div style="padding: 20px 0 20px 0;">
		<!-- 条件查询 -->
		<el-form :inline="true" :model="selectForm" class="demo-form-inline">
			<div class="flex sb">
				<div>
					<el-form-item label="时间">
						<el-date-picker v-model="selectForm.time" type="date">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="姓名">
						<el-select v-model="selectForm.userId" placeholder="巡检人">
							<el-option v-for="item in users" :label="item.userName" :value="item.userId">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getAll()">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="handleClear">重置</el-button>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="dc()">导出</el-button>
					</el-form-item>
					<div style="float: right;margin-right: 20px;">
						<div style="display: inline-block;margin-right: 10px;">
							<el-upload action="/api/admin/exportAttendance/importAttendancePlan" name="file" :show-file-list="false"
								:headers="headers" :on-success="success">
								<el-button type="primary">导入考勤计划表</el-button>
							</el-upload>
						</div>
						<el-button type="primary" @click="addTemplate">下载导入模板</el-button>
					</div>
				</div>
			</div>
		</el-form>
		<!-- 表格内容 -->

		<el-table :data="data" ref="multipleTable" tooltip-effect="dark" style="width: 100%">
			<el-table-column type="selection" width="45px"></el-table-column>
			<el-table-column label="序号" width="62px" type="index">
			</el-table-column>
			<template v-for='(col) in tableData'>
				<el-table-column :show-overflow-tooltip="true" :prop="col.prop" :label="col.label" :key="col.prop"
					width="124px">
				</el-table-column>
			</template>
			<el-table-column label="操作" width="80" align="center">
				<template slot-scope="{row}">
					<el-button type="text" @click="setRow(row)">修改</el-button>

				</template>
			</el-table-column>
		</el-table>
		<el-dialog title="修改" :visible.sync="isShow" width="30%">
			<div style="margin-bottom: 10px;font-weight: 800;">{{name}}的考勤计划</div>
			<el-form ref="form" :model="form" label-width="100px">
				<template v-for="(item,index) in list">
					<el-form-item :label="item.time">
						<el-select :disabled="item.status!='未打卡'" v-model="item.type">
							<el-option label="早" value="早"></el-option>
							<el-option label="夜" value="夜"></el-option>
							<el-option label="休" value="休"></el-option>
						</el-select>
					</el-form-item>
				</template>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="isShow = false">取 消</el-button>
				<el-button type="primary" @click="ok">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import publicExport from '../../assets/js/publicExport.js';
	export default {
		data() {
			return {
				headers: { //请求头
					Authorization: localStorage.access_token,
				},
				selectForm: {
					time: null,
					userId: null
				},
				oldSelect: {

				},
				list:[],
				name:null,
				data: [],
				users: [],
				tableData: [],
				title: '考勤计划表',
				isShow: false,
				form: {}
			}
		},
		mounted() {

			this.oldSelect = JSON.parse(JSON.stringify(this.selectForm))
			this.getAll()
			this.getUser()
		},
		methods: {
			success(res) {
				if (res.code == 0) {
					this.getAll()
					this.$message.success("导入成功")
				} else {
					this.$message.error("导入失败")
				}
			},
			addTemplate() { //下载导入模板
				this.$http.post(`/api/exportAttendance/downloadAttendanceTemplate`, {}, {
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json;charset=utf-8",
					},
					responseType: "blob"
				}).then(res => {
					const link = document.createElement("a");
					let blob = new Blob([res.data], {
						type: "application/vnd.ms-excel"
					});
					link.style.display = "none";
					link.href = URL.createObjectURL(blob);
					link.download = "考勤导入模板.xls";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				})
			},
			ok() {
				this.$http.post("/api/bdCheckWorkAttendance/updateAttendancePlan",{
					list:this.list
				}).then(res=>{
					if(res.data.code==0){
						this.$message.success(res.data.message)
						this.isShow=false
						this.getAll()
					}
					console.log(res)
				})
			},
			setRow(val) {
				console.log(val)
				this.isShow = true
				this.$http.get("/api/bdCheckWorkAttendance/selectAttendancePlanInfo",{
					params: {
						time: this.selectForm.time,
						userId: val.userId
					}
				}).then(res => {
					this.name=res.data.data.name
					this.list=res.data.data.list
					console.log(res)
				})
			},
			getUser() {
				this.$http.get("/api/bdCheckWorkAttendance/selectSecurityUser").then(res => {
					this.users = res.data.data
				})
			},
			getAll() {
				if (this.selectForm.time == null) {
					this.selectForm.time = new Date().getTime()
				}
				this.$http.get("/api/bdCheckWorkAttendance/selectAttendancePlan", {
					params: {
						...this.selectForm
					}
				}).then(res => {
					this.data = res.data.data.list
					this.tableData = res.data.data.headerList
					console.log(res)
				})
			},
			handleClear() {
				this.selectForm = JSON.parse(JSON.stringify(this.oldSelect))
				this.getAll()
			},
			dc() {
				publicExport("/api/exportAttendance/exportAttendancePlan", this.selectForm, this.title)
			},
			selectArInfo(val) {
				this.selectArr = val
			}

		}
	}
</script>

<style scoped="scoped">
</style>
